import { packets, events, PING_CHECK_INTERVAL } from './SocketConstant'
import {HeSocketImpl} from './HeSocketImpl'

class HeSocket {
    constructor(url, { headers = {} } = {}) {
      this.isConnected = false
      this.url = url
      this.headers = headers
    }
  
    setHeader(key, val) {
      this.headers[key] = val
      this.socketInstance = null
    }
  
    connect() {
      return new Promise((resolve, reject) => {
        if (META.platform === XcloverPlatform.wechatgame) {
          this.socketInstance = mini.connectSocket({
            url: this.url,
            header: this.headers
          })
        }else {
          this.socketInstance = HeSocketImpl.connectSocket({
            url: this.url,
            header: this.headers
          })
        }
        this.socketInstance.onOpen(response => {
          cc.log("========== new socket onOpen")
          cc.log("$$$$this.socketInstance", this.socketInstance);
          this.isConnected = true
          //this.ping();
          this.fire('connect')
          resolve(response)
        })
        this.socketInstance.onError(error => {
          cc.log("========== new socket onError")
          if (window.logCenter) {
            let msg = {
              message: "on ws error: " + JSON.stringify(error)
            }
            window.logCenter.log(msg)
          }
          if (this.isConnected) {
            this.fire('socket_error', error)
          } else {
            reject(error)
          }
        })
        this.socketInstance.onMessage(message => {
          cc.log("========== new socket onMessage", message)
          this._handleMessage(message)
        })
        this.socketInstance.onClose(result => {
          cc.log("========== new socket onClose")
          if (result) {
            let code = result.code
            let reason = result.reason || ""
            if (!(code == 1000 && reason.length == 0) && (reason != "interrupted")) {
              // 特殊的log才发到logcenter
              let message = "pvp on ws close: " + JSON.stringify(result)
              if (window.logCenter) {
                let msg = {
                  message: message
                }
                window.logCenter.log(msg)
              } else {
                console.log(message)
              }
            }
          }
          this.fire('close')
          this.isConnected = false
          this.destory()
        })
        this.startHeartBreak()
      })
    }
  
    startHeartBreak() {
      let self = this
      this.heartBreakId = setInterval(() => {
        if (!self.isConnected) {
          self.stopHeardBreak()
          return
        }
        self.ping()
      }, PING_CHECK_INTERVAL)
    }

    stopHeardBreak() {
      if (this.heartBreakId) {
        clearInterval(this.heartBreakId)
        this.heartBreakId = null 
      }
    }

    ping() {
      setTimeout(() => {
        if (!this.isConnected) return
        this.socketInstance.send({
          data: [packets.ping, events.EVENT, JSON.stringify(['probe'])].join('')
        })
      }, PING_CHECK_INTERVAL)
    }
  
    close() {
      return new Promise((resolve, reject) => {
        if (this.isConnected) {
          this.isConnected = false
          cc.log('close socket')
          this.socketInstance.onClose(() => {
            cc.log("just onClose there")
            resolve()
          })
          this.socketInstance.close()
        } else {
          reject(new Error('socket is not connected'))
        }
        // 微信上面 主动关闭socket的时候不会触发 close 事件
        // 不能触发是因为 是全局监听的 事件，没有在对应的 instance 上面监听
        // if (META.platform === XcloverPlatform.wechatgame) {
        //   this.fire('close')
        // }
      })
    }
  
    emit(type, ...params) {
      const data = [type, ...params]
      cc.log('socket emit', type, ...params)
      let socketStatus = null
      if (META.platform === XcloverPlatform.wechatgame) {
        socketStatus = this.socketInstance.readyState
      }else {
        socketStatus = this.socketInstance.scoket && this.socketInstance.scoket.readyState
      }
      if (socketStatus !== WebSocket.OPEN && !(window.mini && mini.getPlatform() == "qq_lightgame")) {
        this.fire('socket_error', error)
        cc.log('socket emit error', type, ...params)
        return
      }
      try {
        this.socketInstance.send({
          data: [packets.message, events.EVENT, JSON.stringify(data)].join('')
        })
      } catch (error) {
        this.fire('socket_error', error)
      }
    }
  
    destory() {
      this.headers = {}
      this.removeAllListeners()
      this.stopHeardBreak()
    }
  
    _handleMessage({ data }) {
      const [match, packet, event, content] = /^(\d)(\d?)(.*)$/.exec(data)
      if (+event === events.EVENT) {
        switch (+packet) {
          case packets.message:
            let pack
            try {
              pack = JSON.parse(content)
            } catch (error) {
              cc.error('解析 ws 数据包失败：')
              cc.error(error)
            }
            const [type, ...params] = pack
            this.fire(type, ...params)
            cc.log('socket receive', type, ...params)
            break
        }
      } else if (+packet == packets.pong) {
        this.ping()
      }
    }
  
    _request({ event, expectEvent, timeout = 5, retry = 2, data } = {}) {
      return new Promise((resolve, reject) => {
        let timer
        if (timeout !== 0) {
          timer = setTimeout(() => {
            reject()
          }, timeout)
        }
        function onExpectEventReturn(...args) {
          clearTimeout(timer)
          socket.off(expectEvent, onExpectEventReturn)
          resolve(...args)
        }
        socket.on(expectEvent, onExpectEventReturn)
        socket.emit(event, ...data)
      })
    }
  
    request(config) {
      return this._request(config).catch(e => {
        if (config.retry) {
          config.__retryCount = config.__retryCount || 0
          config.__retryCount++
          cc.log('socket retry', config)
          return this.request(config)
        } else {
          return Promise.reject(e)
        }
      })
    }
  }

  export default HeSocket